export default __webpack_public_path__ + "static/media/isabella.2009c225.jpeg";